module.exports = __webpack_public_path__ + "static/media/icon-autodiagnostico.be327cbc.svg";